import { Box, Group, createStyles } from '@mantine/core';
import { Button, Text } from '@repo/foundations';
import { memo } from 'react';

const useStyles = createStyles((theme) => ({
	floatingBar: {
		position: 'absolute',
		bottom: theme.spacing.lg,
		left: '50%',
		transform: 'translateX(-50%)',
		zIndex: 1000,
		backgroundColor: theme.other.getColor('surface/primary/default'),
		borderRadius: theme.radius.md,
		padding: theme.spacing.xs,
		paddingLeft: theme.spacing.md,
		boxShadow: theme.shadows.md,
	},
	toastText: {
		paddingRight: theme.spacing.xs,
	},
}));

interface FloatingSaveDiscardBarProps {
	hasChanges: boolean;
	isUpdating: boolean;
	onSave: () => void;
	onDiscard: () => void;
}

export const FloatingSaveDiscardBar = memo(
	({
		hasChanges,
		isUpdating,
		onSave,
		onDiscard,
	}: FloatingSaveDiscardBarProps) => {
		const { classes } = useStyles();

		if (!hasChanges) {
			return null;
		}

		return (
			<Box className={classes.floatingBar}>
				<Group spacing="xs" position="center">
					<Text
						size="sm"
						color="text/primary/default"
						className={classes.toastText}
					>
						Unsaved changes
					</Text>
					<Button
						variant="default"
						size="md"
						onClick={onDiscard}
						disabled={isUpdating}
					>
						Discard
					</Button>
					<Button
						variant="primary"
						size="md"
						onClick={onSave}
						loading={isUpdating}
					>
						Save
					</Button>
				</Group>
			</Box>
		);
	}
);
